export const permissionsBudget = [
  "budget",
  "everything-full",
  "everything-readonly",
];
